// extracted by mini-css-extract-plugin
var _1 = "ScreenWarning__button--zFkNl";
var _2 = "ScreenWarning__img--PhkeK";
var _3 = "ScreenWarning__main--X5nA9";
var _4 = "ScreenWarning__message--EMm6w";
export { _1 as "button", _2 as "img", _3 as "main", _4 as "message" }
